<script setup lang="ts">
import useModel from './../model/model'
import { useCabinetReports } from '@/pages/object/CabinetReports'
import { onBeforeMount } from 'vue'

const { loadTable, headers, data, total } = useModel()
const model = useCabinetReports()

const { isFetching, refetch } = loadTable(model.filter)

onBeforeMount(() => {
  model.filter.page = 1
  model.filter.per_page = 10
  model.setCallback(refetch)
})
</script>

<template>
  <VDataTableServer
    v-model:items-per-page="model.filter.per_page"
    v-model:page="model.filter.page"
    :loading="isFetching"
    :headers="headers"
    :items="data"
    :items-length="total"
    :items-per-page-options="model.perPageList"
    @update:options="refetch"
  >
    <template v-slot:item.index="{ index }">
      {{ index + 1 + model.filter.per_page * (model.filter.page - 1) }}
    </template>
  </VDataTableServer>
</template>
